<div class="__upload-container">
  <label for="file">
    <i class="bi bi-upload"></i>
  </label>
  <input #file type="file" name="file" id="file" class="inputfile" (change)="extractFileContent($event?.target?.files)"/>
</div>
